<div class="modal-header">
  <h4 class="modal-title">
    {{ 'tenders.market-watches.modal-manage-frequency-watch.title' | translate }}
  </h4>
  <button type="button" class="btn-close" aria-label="close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <div class="modal-message">
    {{ 'tenders.market-watches.modal-manage-frequency-watch.message' | translate }}
  </div>
  <div class="modal-info">
    {{ 'tenders.market-watches.modal-manage-frequency-watch.info' | translate }}
  </div>
  <digest-week-days-selector class="d-flex" [days]="days" (daySelected)="onSelectDay($event)" />
</div>
<div class="modal-footer">
  <button type="button" class="cancel fw-bold" (click)="cancel()">
    {{ 'tenders.market-watches.modal-manage-frequency-watch.cancel' | translate }}
  </button>
  <button type="button" class="btn confirm d-flex" [disabled]="getSelectedDays().length === 0" (click)="confirm()">
    <span class="text-uppercase fw-bold align-self-center">{{
      'tenders.market-watches.modal-manage-frequency-watch.confirm' | translate
    }}</span>
  </button>
</div>
